import React, { useState } from 'react';
import { MenuItemsAboutUs } from './MenuItems';
import './Dropdown.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function DropdownAboutUs({ closeMenu }) {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const { t } = useTranslation();

  return (
    <>
      <ul
        onClick={handleClick}
        className={click ? 'dropdown-menu clicked' : 'dropdown-menu'}
      >
{MenuItemsAboutUs.map((item, index) => {
  const translationKey = 'navbar.about_us_items.' + item.name;
 
  return (
    <li key={index}>
      <Link
        className={item.cName}
        to={item.path + "#main"}
        onClick={() => {
          closeMenu();
          setClick(false);
        }}
      >
                 {t('navbar.items.about_us_items.' + item.name)}
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default DropdownAboutUs;